export enum Result {
    SUCCESS = 'Success',
    UPDATED = 'Updated',
    DELETED = 'Deleted'
}